// Load CSS
import './scss/main.scss';

// Import
import { onReady } from './js/utilities'; 
import GlossaryDialog from './js/glossary-dialog';

// Invoke classes when the DOM is ready
onReady(() => {
	new GlossaryDialog();
});